import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import axios from "axios";

const Pricing = () => {
  const [selectedPlan, setSelectedPlan] = useState(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [planns, setPlans] = useState([]);

  const handlePlanSelection = (plan) => {
    setSelectedPlan(plan);
    navigate("/personal-info", { state: { selectedPlan: plan } });
  };

  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const response = await fetch('https://api.theonlysale.com/api/get/plans'); // Adjust the URL as necessary
        if (!response.ok) {
          throw new Error('Failed to fetch plans');
        }
        const data = await response.json();
        setPlans(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPlans();
  }, []);

  console.log("planet", planns);

  // Show a loading indicator while the data is being fetched
  if (loading) {
    return <div>Loading...</div>;
  }

  // Show an error message if there is an error
  if (error) {
    return <div>Error: {error}</div>;
  }

  const plans = [
    {
      title: planns[0]?.productName || "Basic Plan",
      price: planns[0] ? `${planns[0].formattedPrice} CHF` : "$19",
      description:
        "Ideal for those who love to shop and explore a wide range of products.",
      features: [
        "Access to all product listings",
        "Fast and secure checkout",
        "Personalized product recommendations",
        "Regular discounts and offers",
        "Basic customer support",
      ],
      productId:planns[0]?.product,
      priceId:planns[0]?.id,
      role:"user"
    },
    {
      title: planns[1]?.productName || "Marketplace Pro",
      price: planns[1] ? `${planns[1].formattedPrice} CHF` : "$49",
      description:
        "Perfect for users who want to take part in the community by buying and selling.",
      features: [
        "Everything in the Shopper plan, plus:",
        "Ability to list and sell second-hand items",
        "Enhanced visibility for your listings",
        "Priority customer support",
        "Access to exclusive seller analytics",
      ],
      productId:planns[1]?.product,
      priceId:planns[1]?.id,
      role:"premium"
    },
    {
      title: planns[2]?.productName || "Vendor Pro",
      price: planns[2] ? `${planns[2].formattedPrice} CHF` : "$149",
      description:
        "Designed for businesses that want to expand their reach by adding new products to the marketplace.",
      features: [
        "Everything in the Marketplace Pro plan, plus:",
        "Ability to add and sell new items",
        "Bulk listing options for large inventories",
        "Featured product placement in search results",
        "Comprehensive sales and inventory reports",
      ],
      productId:planns[2]?.product,
      priceId:planns[2]?.id,
      role:"business"
    },
  ];

  return (
    <>
      <Header />
      <section className="bg-white dark:bg-gray-900">
        <div className="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6">
          <div className="mx-auto max-w-screen-md text-center mb-8 lg:mb-12">
            <h2 className="mb-4 text-4xl tracking-tight font-extrabold text-gray-900 dark:text-white">
              Elevate Your Shopping Experience with OnlySale
            </h2>
            <p className="mb-5 font-light text-gray-500 sm:text-xl dark:text-gray-400">
              At OnlySale, we're dedicated to revolutionizing the e-commerce
              landscape. Discover how our innovative platform brings you the
              best deals, top-quality products, and a seamless shopping
              experience designed to meet your needs and drive your business
              forward.
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-8 lg:gap-10">
            {plans.map((plan, index) => (
              <div
                key={index}
                className="flex flex-col p-6 max-w-lg text-center text-gray-900 bg-white rounded-lg border border-gray-100 shadow dark:border-gray-600 xl:p-8 dark:bg-gray-800 dark:text-white flex-grow"
              >
                <h3 className="mb-4 text-2xl font-semibold">{plan.title}</h3>
                <p className="font-light text-gray-500 sm:text-lg dark:text-gray-400">
                  {plan.description}
                </p>
                <div className="flex justify-center items-baseline my-8">
                  <span className="mr-2 text-5xl font-extrabold">
                    {plan.price}
                  </span>
                  <span className="text-gray-500 dark:text-gray-400">
                    /month
                  </span>
                </div>
                <ul role="list" className="mb-8 space-y-4 text-left">
                  {plan.features.map((feature, i) => (
                    <li key={i} className="flex items-center space-x-3">
                      <svg
                        className="flex-shrink-0 w-5 h-5 text-green-500 dark:text-green-400"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clipRule="evenodd"
                        ></path>
                      </svg>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
                <button
                  onClick={() => handlePlanSelection(plan)}
                  className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                >
                  Get started
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default Pricing;
